import { NursingHomeQuickOverview } from './NursingHomeQuickOverview';
import { QuickCreation } from './QuickCreation';
import {
  useEmployeeIsNursingHomeAdminOrManager,
  useNursingHomeContext,
} from '@pflegenavi/frontend/nursing-home-context';
import { useEmployeeIsNursingHomeAdmin } from '@pflegenavi/frontend/nursing-home-context';
import { useMemo, type FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ScaEnrollmentButton } from '@pflegenavi/web-components';
import { FeatureFlag } from '@pflegenavi/shared/api';
import { useFeatureFlagEnabled } from '@pflegenavi/frontend/feature-flags';
import {
  useGetLegalEntities,
  useMangopayScaEnrollment,
} from '@pflegenavi/frontend/api-nursing-home';

const ScaButton: FC = () => {
  const { selectedNursingHome } = useNursingHomeContext();

  const { data: legalEntities, refetch } = useGetLegalEntities();

  const legalEntity = useMemo(() => {
    return legalEntities?.data?.find(
      (entity) => entity.id === selectedNursingHome?.legalEntityId
    );
  }, [legalEntities?.data, selectedNursingHome?.legalEntityId]);

  const isAdmin = useEmployeeIsNursingHomeAdmin();

  const { mutateAsync: mangopayScaEnrollment } = useMangopayScaEnrollment();
  const [searchParams] = useSearchParams();
  const controlStatus = searchParams.get('controlStatus');

  const isEnrolled = legalEntity?.mangopay_sca_enrolled ?? false;

  // Show button if not enrolled AND is admin, OR if enrollment process is active
  const showScaEnrollmentButton =
    legalEntity && isAdmin && (!isEnrolled || controlStatus !== null);

  if (!showScaEnrollmentButton) {
    return null;
  }

  return (
    <ScaEnrollmentButton
      isEnrolled={isEnrolled}
      onEnroll={() =>
        mangopayScaEnrollment({
          legal_entity_id: selectedNursingHome?.legalEntityId ?? '',
          return_url: encodeURIComponent(window.location.href),
        })
      }
      refetch={refetch}
      showCloseButton={false}
    />
  );
};

export const MenuItems: FC = () => {
  const employeeIsNursingHomeAdminOrManager =
    useEmployeeIsNursingHomeAdminOrManager();

  const scaEnrollmentEnabled = useFeatureFlagEnabled(
    FeatureFlag.dev_ScaEnrollment
  );

  if (!employeeIsNursingHomeAdminOrManager) {
    return null;
  }

  return (
    <>
      {scaEnrollmentEnabled && <ScaButton />}
      <QuickCreation />
      <NursingHomeQuickOverview />
    </>
  );
};
